import { RacwaStepperPageTitle, RacwaStepperPageTitleProps } from "@racwa/react-components";
import { ClaimNumberDisplay, useGetSessionState } from "raci-react-library";
import { MoreAboutTheAccidentState } from "../../../views/MoreAboutTheAccident/types";
import { FormRoute } from "../../routing/routes.config";

interface PageTitleProps extends Pick<RacwaStepperPageTitleProps, "title" | "id"> {
  showClaimNumber?: boolean;
}

const PageTitle = ({ title, id, showClaimNumber }: PageTitleProps) => {
  const { claimNumber } = useGetSessionState<MoreAboutTheAccidentState>(FormRoute.MoreAboutTheAccident);

  return (
    <RacwaStepperPageTitle
      id={id}
      data-testid={id}
      title={title}
      subtitle={claimNumber ? <ClaimNumberDisplay number={claimNumber} /> : undefined}
    />
  );
};

export default PageTitle;
